/* unplugin-vue-components disabled */import script from "./HeaderBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBanner.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBanner.vue?vue&type=style&index=0&id=7be3165e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be3165e"]])

export default __exports__